import { PromoContentComponentProps, PromoType } from "../types";
import { useState } from "react";
import { PromoContent } from "../Content";
import { Transition } from "@headlessui/react";

// Designed specifically to use with PromoSize.XS
export const PromoBanner = (
  props: Omit<PromoContentComponentProps, "promoType">
) => {
  const [isOpened, setIsOpened] = useState(true);

  return (
    <Transition
      enter="transition duration-100 ease-out"
      enterFrom="transform scale-95 opacity-0"
      enterTo="transform scale-100 opacity-100"
      leave="transition duration-75 ease-out"
      leaveFrom="transform scale-100 opacity-100"
      leaveTo="transform scale-95 opacity-0"
      show={isOpened}
      className="absolute bottom-5 left-5 z-50 border border-alpha-80 rounded-lg shadow-lg"
    >
      <PromoContent
        {...props}
        promoType={PromoType.Banner}
        onClose={() => {
          props.onClose?.();
          setIsOpened(false);
        }}
      />
    </Transition>
  );
};
